/**
 * @module components\ghRange
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class GhRange extends Vue {
  @Prop({ default: () => {} })
  private range!: IRange;

  private get lowSymbol() {
    if (this.range) {
      if (this.range.includeLower) {
        return "[";
      }
    }
    return "(";
  }

  private set lowSymbol(val: string) {
    let flag = false;
    if (val === "[") {
      flag = true;
    }
    this.$set(this.range, "includeLower", flag);
  }

  private get upperSymbol() {
    if (this.range) {
      if (this.range.includeUpper) {
        return "]";
      }
    }
    return ")";
  }

  private set upperSymbol(val: string) {
    let flag = val === "]" ? true : false;
    this.$set(this.range, "includeUpper", flag);
  }

  private rangeSymbol = "~";
}
